module.exports = "https://www.gc-pro.gnp.com.mx/4f6267514d8c041209da37e28ca16f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow_right.png
// module id = 1797
// module chunks = 0